import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('MEASUREMENT UNITS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class MeasurementUnitsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'measurementUnits' como el nombre del recurso a la clase base
    super('measurementUnits');
    log.debug('Servicio de Unidades de Medida inicializado');
  }

}
